import { render, staticRenderFns } from "./BPF.vue?vue&type=template&id=6c8a8bf4&"
import script from "./BPF.vue?vue&type=script&lang=js&"
export * from "./BPF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports